export enum IndicatorPrimarySourceTypes {
  CHECK_IN = 'checkIn',
  CORE_PILLAR_QUESTIONNAIRE = 'corePillarQuestionnaire',
  HOLISTIC_QUESTIONNAIRE = 'holisticQuestionnaire',
  SPECIALISED_QUESTIONNAIRE = 'specialisedQuestionnaire',
  REFLECTION = 'reflection',
  COMMENT = 'comment',
  SPEAK_UP = 'speakUp',
  SYSTEM_GENERATED = 'systemGenerated',
}
